var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",class:[{ circle: _vm.circle }, _vm.size]},[_c('span',{staticClass:"text-white mb-0",class:_vm.fontSize},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }